export const initialCalendar = () => {
	const initialTimeslots = [];
	const date = new Date();
	// const currentDay = date.getDay();
	const lastDayOfMonth = 32 - new Date(date.getFullYear(), date.getMonth(), 32).getDate();
	const currentDate = date.getDate();
	for (let i = currentDate; i < lastDayOfMonth + 1; i++) {
		const nextDate = new Date(date.getFullYear(), date.getMonth(), i);
		nextDate.setHours(nextDate.getHours() + 3);
		initialTimeslots.push({
			START_DATE: nextDate.toISOString(),
			END_DATE: nextDate.toISOString(),
			RESOURCE_ID: 'none',
		});
		nextDate.setHours(nextDate.getHours() + 6);
		initialTimeslots.push({
			START_DATE: nextDate.toISOString(),
			END_DATE: nextDate.toISOString(),
			RESOURCE_ID: 'none',
		});
		nextDate.setHours(nextDate.getHours() + 4);
		initialTimeslots.push({
			START_DATE: nextDate.toISOString(),
			END_DATE: nextDate.toISOString(),
			RESOURCE_ID: 'none',
		});
	}
	return initialTimeslots;
};
